import { styled } from '../../Styles/stitches.config'

export const StyledErrorBlock = styled('div', {
    bgc: '$white',
    border: '1px solid $error600',
    color: '$error600',
    br: '$1',
    p: '$2',
    textAlign: 'center',
})
